// removed by extract-text-webpack-plugin
module.exports = {"theme":"#f7b600","themepei":"#e50113"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/element-variables.scss
// module id = VUEL
// module chunks = 38